
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_1wepg_1ri2i_145",
  "description": "awsui_description_1wepg_1ri2i_146",
  "label": "awsui_label_1wepg_1ri2i_147",
  "outline": "awsui_outline_1wepg_1ri2i_155",
  "show-outline": "awsui_show-outline_1wepg_1ri2i_158",
  "native-input": "awsui_native-input_1wepg_1ri2i_162",
  "wrapper": "awsui_wrapper_1wepg_1ri2i_166",
  "label-wrapper": "awsui_label-wrapper_1wepg_1ri2i_172",
  "empty-content": "awsui_empty-content_1wepg_1ri2i_183",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_1ri2i_193",
  "label-disabled": "awsui_label-disabled_1wepg_1ri2i_201",
  "description-disabled": "awsui_description-disabled_1wepg_1ri2i_202",
  "control": "awsui_control_1wepg_1ri2i_206"
};
  